import { get, put } from '@/redux/requests/api.js';

export const getConnections = (callback) => {
  return get('/v1/pieve/connections', {
    action: 'GET_CONNECTIONS',
    loader: 'getConnections',
    callback
  });
};

export const getCompanyConnections = (callback) => {
  return get('/v1/pieve/connections', {
    action: 'GET_COMPANY_CONNECTIONS',
    loader: 'getCompanyConnections',
    query: { isCompany: true },
    callback
  });
};

export const putCredentialRole = ({ credentialId, roleId, isActive } = {}, callback) => {
  return put('/v1/pieve/credential-role', {
    action: 'PUT_CREDENTIAL_ROLE',
    loader: 'putCredentialRole',
    data: {
      credentialId: String(credentialId || '').trim(),
      roleId: String(roleId || '').trim(),
      isActive: Boolean(isActive)
    },
    meta: { credentialId, roleId, isActive: Boolean(isActive) },
    callback
  });
};
